import {
	registerEventEndTeardownSave,
	registerInGameCompensationRewardsFetcher,
} from "@/event";
import SocketService from "@/libs/SocketService";

export { EmitStores } from "@/libs/SocketService";

let cache: SocketService | null = null;

const useSocketService = (): SocketService => {
	if (!cache) {
		cache = new SocketService();
		registerEventEndTeardownSave(payload =>
			cache!.emitSaveRequest(payload),
		);
		registerInGameCompensationRewardsFetcher(() =>
			cache!.getInGameCompensationRewards(),
		);
	}
	return cache;
};

export default useSocketService;
